import cookiesPolicy from "fg-frontend/components/CookiesPolicy4/index";
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import configureWebComponents from './configureWebComponents';

cookiesPolicy({
	disableRwdImg: true,
	enableModal: true,
	enableRenderModalFooterTechnicalButton: true,
});


connectWebComponents(configureWebComponents);


// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureWeb.js